import axios from 'axios';

//const AUTH_API_BASE_URL = 'http://localhost:8080/api/auth/';
const AUTH_API_BASE_URL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PROD_URL + '/api/auth/' : 'http://localhost:8080/api/auth/';


class AuthService {

    login(username, password) {
      console.log(process.env.REACT_APP_PROD_URL);
      console.log(process.env.NODE_ENV);
      console.log(AUTH_API_BASE_URL);
      return axios
        .post(AUTH_API_BASE_URL + "signin", {
          username,
          password
        })
        .then(response => {
          if (response.data.accessToken) {
            localStorage.setItem("user", JSON.stringify(response.data));
          }
  
          return response.data;
        });
    }
  
    logout() {
      localStorage.removeItem("user");
    }
  
    register(name,username, email, password) {
      return axios.post(AUTH_API_BASE_URL + "signup", {
        name,
        username,
        email,
        password
      });
    }
  
    getCurrentUser() {
      return JSON.parse(localStorage.getItem('user'));;
    }
  }
export default new AuthService();